export default __webpack_public_path__ + "static/data-vis-single-color-charts-light-73432df876bc741855e95ef3b994ed54.png";